export default function NewsworthyToolbarIcon() {
  return (
    <svg width={20} height={20}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#D7E057"
          d="M2.874 1.024C2.787 2.045 1.72 2.207 1.72 2.207c.916.043 1.144 1.241 1.144 1.241.02-.854 1.179-1.254 1.179-1.254-.869-.052-1.17-1.17-1.17-1.17z"
        />
        <path
          fill="#3A312A"
          fillRule="nonzero"
          d="M4.052 2.062C3.29 2.016 3.005 1 3.002.99a.132.132 0 1 0-.26.023c-.077.902-1.002 1.057-1.04 1.063a.133.133 0 0 0 .013.263c.799.038 1.017 1.123 1.02 1.134a.133.133 0 0 0 .263-.022c.017-.751 1.079-1.128 1.09-1.132a.132.132 0 0 0-.036-.257zm-1.2.913c-.12-.276-.329-.61-.672-.784.26-.124.567-.345.725-.73.138.271.372.608.738.77-.266.145-.613.39-.792.744z"
        />
        <path
          fill="#D7E057"
          d="M.953 2.524c-.06.722-.815.836-.815.836.648.03.81.878.81.878.013-.604.833-.887.833-.887-.614-.037-.828-.827-.828-.827z"
        />
        <path
          fill="#3A312A"
          fillRule="nonzero"
          d="M1.789 3.219c-.51-.03-.706-.723-.707-.73a.133.133 0 1 0-.26.023c-.052.607-.678.713-.704.717a.132.132 0 0 0 .014.263c.534.025.684.763.685.77a.133.133 0 0 0 .263-.021c.012-.504.737-.762.744-.765a.132.132 0 0 0-.035-.257zm-.848.6a1.136 1.136 0 0 0-.394-.466 1.06 1.06 0 0 0 .431-.434c.094.165.235.349.437.46a1.385 1.385 0 0 0-.474.44z"
        />
        <path
          fill="#D7E057"
          d="M.953.17c-.06.722-.815.836-.815.836.648.03.81.878.81.878.013-.604.833-.887.833-.887C1.167.961.953.17.953.17z"
        />
        <path
          fill="#3A312A"
          fillRule="nonzero"
          d="M1.789.865c-.51-.03-.706-.723-.707-.73a.133.133 0 1 0-.26.023C.77.766.143.872.117.876a.132.132 0 0 0 .014.263c.534.025.684.764.685.771a.133.133 0 0 0 .263-.022c.012-.504.737-.762.744-.764A.133.133 0 0 0 1.79.865zm-.848.6A1.133 1.133 0 0 0 .547 1C.711.907.874.767.978.565c.094.165.235.349.437.461a1.385 1.385 0 0 0-.474.44z"
        />
        <path
          fill="#FCE8CB"
          d="M18.988.132H5.957a.874.874 0 0 0-.875.873v16.363a2.466 2.466 0 0 1-1.934 2.406l-.036.06h14.78c1.088 0 1.97-.88 1.97-1.966V1.005a.873.873 0 0 0-.874-.873z"
        />
        <path
          fill="#3A312A"
          d="M18.988 0H15.72a.133.133 0 1 0 0 .265h3.268c.409 0 .741.332.741.74v16.863a1.838 1.838 0 0 1-1.838 1.833H3.756c.256-.124.491-.292.696-.496a2.582 2.582 0 0 0 .763-1.837V1.005c0-.408.333-.74.742-.74h8.412a.133.133 0 1 0 0-.265H5.957C5.402 0 4.95.45 4.95 1.005v16.363a2.331 2.331 0 0 1-1.83 2.277.133.133 0 0 0-.084.06l-.037.06a.132.132 0 0 0 .113.202h14.78c1.16 0 2.103-.942 2.103-2.1V1.006C19.995.45 19.543 0 18.988 0z"
        />
        <path
          fill="#87796F"
          d="M1.013 5.311a.873.873 0 0 0-.875.873v11.183a2.47 2.47 0 0 0 2.472 2.467 2.47 2.47 0 0 0 2.472-2.467V5.311h-4.07z"
        />
        <path
          fill="#3A312A"
          d="M5.082 5.179h-4.07c-.555 0-1.007.45-1.007 1.005v4.372a.133.133 0 0 0 .266 0V6.184c0-.408.333-.74.742-.74H4.95v11.923a2.34 2.34 0 0 1-4.68 0V11.95a.133.133 0 0 0-.265 0v5.417a2.605 2.605 0 0 0 5.21 0V5.311a.133.133 0 0 0-.133-.132z"
        />
        <path
          fill="#F16C7A"
          d="M17.093 5.93H7.834a.71.71 0 0 0-.71.708V9.67a.71.71 0 0 0 .71.71h9.259a.71.71 0 0 0 .71-.71V6.638a.71.71 0 0 0-.71-.709z"
        />
        <path
          fill="#3A312A"
          fillRule="nonzero"
          d="M17.093 5.797H7.834a.843.843 0 0 0-.842.84V9.67c0 .464.378.841.842.841h9.259a.843.843 0 0 0 .843-.84V6.637a.843.843 0 0 0-.843-.841zm.577 3.873a.578.578 0 0 1-.577.577H7.834a.577.577 0 0 1-.577-.577V6.638c0-.318.26-.576.577-.576h9.259c.318 0 .577.258.577.576V9.67z"
        />
        <path
          fill="#8AC6DD"
          d="M17.21 1.884H7.717a.593.593 0 0 0-.594.593v.882c0 .327.266.592.594.592h9.491a.593.593 0 0 0 .594-.592v-.882a.593.593 0 0 0-.594-.593z"
        />
        <g fill="#3A312A">
          <path
            fillRule="nonzero"
            d="M17.21 1.752H7.717c-.4 0-.727.325-.727.725v.882c0 .4.326.725.727.725h9.491c.4 0 .727-.326.727-.725v-.882c0-.4-.326-.725-.727-.725zm.46 1.607a.46.46 0 0 1-.46.46H7.717a.46.46 0 0 1-.461-.46v-.882a.46.46 0 0 1 .461-.46h9.491a.46.46 0 0 1 .461.46v.882z"
          />
          <path d="M17.803 11.999H7.124a.133.133 0 1 0 0 .265h10.68a.133.133 0 1 0 0-.265zm0 1.85H7.124a.133.133 0 1 0 0 .265h10.68a.133.133 0 1 0 0-.265zm0 1.851H7.124a.133.133 0 1 0 0 .264h10.68a.133.133 0 1 0 0-.265zm0 1.85H7.124a.133.133 0 1 0 0 .264h10.68a.133.133 0 1 0 0-.265z" />
        </g>
        <path
          fill="#DECAAD"
          d="M18.988.265h-1.223c.409 0 .741.332.741.74v16.863A1.838 1.838 0 0 1 16.67 19.7h1.222a1.838 1.838 0 0 0 1.838-1.833V1.005a.742.742 0 0 0-.741-.74z"
        />
      </g>
    </svg>
  );
}
